var exports = {
  "Z": "AggregateLabels__tlJhjV",
  "u": "ParentIssueTitle__I-FCRr",
};

module.exports = exports;
